import React from 'react';
const SvgChevronUp = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 32 32", focusable: false }, props),
    React.createElement("path", { d: "M29.09 25.757L16 12.677 2.91 25.757 0 22.857l16-16 16 16z", fillRule: "evenodd" })));
export default SvgChevronUp;
//# sourceMappingURL=ChevronUp.js.map